var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.122,
    height: 27.116,
    viewBox: "0 0 27.122 27.116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "image",
    transform: "translate(-2.25 -2.25)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42831",
    "data-name": "Path 42831",
    d: "M25.736,29.366H5.879A3.629,3.629,0,0,1,2.25,25.736V5.879A3.629,3.629,0,0,1,5.879,2.25H25.736a3.629,3.629,0,0,1,3.629,3.629V25.736a3.629,3.629,0,0,1-3.629,3.629ZM5.879,4.336A1.544,1.544,0,0,0,4.336,5.879V25.736A1.544,1.544,0,0,0,5.879,27.28H25.736a1.544,1.544,0,0,0,1.544-1.544V5.879a1.544,1.544,0,0,0-1.544-1.544Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42832",
    "data-name": "Path 42832",
    d: "M3.292,21.2a1.057,1.057,0,0,1-.793-.362,1.043,1.043,0,0,1,.125-1.474l7.12-6.007a2.781,2.781,0,0,1,3.754.153l3.379,3.379a.7.7,0,0,0,.9,0l3.282-2.378a2.781,2.781,0,0,1,3.393,0l4.519,3.6a1.049,1.049,0,0,1-1.307,1.641l-4.505-3.615a.7.7,0,0,0-.848,0L19.033,18.68a2.781,2.781,0,0,1-3.629-.25l-3.379-3.449a.7.7,0,0,0-.932,0L3.96,20.96A1,1,0,0,1,3.292,21.2Z",
    transform: "translate(0.001 4.081)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42833",
    "data-name": "Path 42833",
    d: "M16.074,13.9A3.824,3.824,0,1,1,19.9,10.074,3.824,3.824,0,0,1,16.074,13.9Zm0-5.562a1.738,1.738,0,1,0,1.738,1.738A1.738,1.738,0,0,0,16.074,8.336Z",
    transform: "translate(3.905 1.562)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.68968e98634d227b348d9dd3b4f4f7b2.svg";
export { ForwardRef as ReactComponent };